import React, { useState } from 'react';
import { Box, Typography, TextField, MenuItem, Button, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDailyActivity } from '../hooks/useDailyActivity';

const activityScale = [
  { value: 1, label: '1 - Sedentary (little to no movement)' },
  { value: 2, label: '2 - Light (walking, household chores)' },
  { value: 3, label: '3 - Moderate (brisk walking, light exercise)' },
  { value: 4, label: '4 - Active (exercise, sports, physical labor)' },
  { value: 5, label: '5 - Very Active (intense exercise, heavy labor)' },
];

interface DailyActivityPageProps {
  onBack?: () => void;
}

const DailyActivityPage: React.FC<DailyActivityPageProps> = ({ onBack }) => {
  const [activityLevel, setActivityLevel] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const { createDailyActivity, loading, error } = useDailyActivity();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await createDailyActivity({ activityLevel: Number(activityLevel) });
    if (success) {
      setSubmitted(true);
      setTimeout(() => {
        setActivityLevel('');
        setSubmitted(false);
      }, 1500);
    }
  };

  return (
    <Box sx={{ maxWidth: 420, mx: 'auto', mt: 8, p: 3, bgcolor: '#fff', borderRadius: 3, boxShadow: 2, position: 'relative' }}>
      {onBack && (
        <Button
          onClick={onBack}
          variant="text"
          size="small"
          sx={{ position: 'absolute', top: 8, left: 8, minWidth: 0, p: 1 }}
        >
          <CloseIcon sx={{ color: '#222', fontSize: 32 }} />
        </Button>
      )}
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, mt: 4, textAlign: 'center' }}>
        Daily Activity
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              select
              label="Activity Level"
              value={activityLevel}
              onChange={e => setActivityLevel(e.target.value)}
              fullWidth
              required
            >
              {activityScale.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading || submitted}
              sx={{ py: 1.2, fontSize: '1.1rem', borderRadius: 8, backgroundColor: '#00A3FF', '&:hover': { backgroundColor: '#0091E6' } }}
            >
              {submitted ? 'Submitted!' : loading ? 'Saving...' : 'Submit'}
            </Button>
          </Grid>
          {error && (
            <Grid item xs={12}>
              <Typography color="error" sx={{ textAlign: 'center' }}>
                {error}
              </Typography>
            </Grid>
          )}
        </Grid>
      </form>
    </Box>
  );
};

export default DailyActivityPage;
